/* eslint-disable react/jsx-props-no-spreading */
import { Divider, Input, Stack, Text, Textarea } from '@chakra-ui/react';

import type { UserDetailsFormData } from '@/client/components/learners/profile/overlay/LearnerProfileUserDetailsFormModal';
import { useAuthStore } from '@/client/services/state/authStore';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default function LearnerProfileUserDetailsForm() {
  const { t } = useTranslation();
  const { authConfig } = useAuthStore();
  const { company } = authConfig;
  const { feature_flags: featureFlags } = company;
  const { enable_user_name_edit: enableUserNameEdit } = featureFlags;

  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<UserDetailsFormData>();

  const { email } = watch();

  const showEmail = !email.startsWith('noemail__');

  const hasFirstNameError = !!errors.firstName;
  const hasLastNameError = !!errors.lastName;

  return (
    <Stack spacing={10}>
      <Stack spacing={6}>
        <Text variant="formSectionHeading">{t('learners.profile.userDetails.title')}</Text>

        <Stack direction={{ base: 'column', md: 'row' }} spacing={6} width="full">
          <Stack spacing={2} width="full">
            <Text variant="formlabel">{t('learners.profile.userDetails.firstName')}</Text>

            <Stack spacing={0}>
              <Input
                {...register('firstName')}
                disabled={!enableUserNameEdit}
                isInvalid={hasFirstNameError}
                variant="warmNeutral"
              />

              <Text variant="formErrorText">
                {hasFirstNameError ? (errors.firstName?.message as string) : ' '}
              </Text>
            </Stack>
          </Stack>

          <Stack spacing={2} width="full">
            <Text variant="formlabel">{t('learners.profile.userDetails.lastName')}</Text>

            <Stack spacing={0}>
              <Input
                {...register('lastName')}
                disabled={!enableUserNameEdit}
                isInvalid={hasLastNameError}
                variant="warmNeutral"
              />

              <Text variant="formErrorText">
                {hasLastNameError ? (errors.lastName?.message as string) : ' '}
              </Text>
            </Stack>
          </Stack>
        </Stack>

        {showEmail && (
          <Stack spacing={2} width="full">
            <Text variant="formlabel">{t('learners.profile.userDetails.email')}</Text>

            <Input {...register('email')} isDisabled variant="warmNeutral" />
          </Stack>
        )}
      </Stack>

      <Divider borderColor="neutral.100" />

      <Stack spacing={6}>
        <Text variant="formSectionHeading">{t('learners.profile.userDetails.about')}</Text>

        <Textarea {...register('about')} variant="warmNeutral" />
      </Stack>
    </Stack>
  );
}
